<template>
  <div
    class="HTML_MEDIAPIC"
    v-show="datas.pictures && datas.pictures.length > 0"
    :class="[datas.pictures.length == 1 ? 'onePic' : '']"
  >
    <el-carousel style="width: 100%" :autoplay="false">
      <el-carousel-item v-for="(item, index) in datas.pictures" :key="index">
        <el-image
          style="width: 100%; height: 100%"
          :src="item"
          fit="contain"
          :preview-src-list="datas.pictures"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// 媒体云下广播级 图片
export default {
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
        pictures: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
        ],
        videos: [],
      }),
    },
  },
  created() {
    console.debug('created HTML_MEDIAPIC:', this.datas)
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.HTML_MEDIAPIC {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3.6vw);
  height: calc(100% - 1.8vw);
  &.onePic {
    .el-carousel__arrow,
    .el-carousel__indicators {
      display: none !important;
    }
  }
  .el-carousel__container,
  .el-carousel {
    height: 100%;
  }
  .el-carousel__indicator--horizontal {
    padding: 1.388vw 0.53333vw;
    .el-carousel__button {
      width: 2.778vw;
    }
  }
  .el-carousel__arrow {
    width: 2.4vw;
    height: 2.4vw;
  }

  /* .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  } */
}
</style>
